export const PURCHASE_REQUISITION_TYPE_PERMISSION = {
  VIEW: 'PURCHASE_REQUISITION_TYPE_VIEW',
  ADD: 'PURCHASE_REQUISITION_TYPE_ADD',
  EDIT: 'PURCHASE_REQUISITION_TYPE_EDIT',
  DEL: 'PURCHASE_REQUISITION_TYPE_DEL',
  ADD_ACCOUNTING: 'PURCHASE_REQUISITION_TYPE_ADD_ACCOUNTING',
  DEL_ACCOUNTING: 'PURCHASE_REQUISITION_TYPE_DEL_ACCOUNTING',
};

export const getOptionLabel = (options = [], value, fallback = '--') => {
  return options.find((item) => Number(item.value) === Number(value))?.label || fallback;
};

export const defaultValues = {
  accounting_list: [],
  review_level_user_list: [],
  is_contract_required: 0,
  default_contract_type_id: null,
  contract_rule_note: '',
};
